export * from '@atcute/oauth-browser-client';

import type { ActorIdentifier } from '@atcute/lexicons';
import { configureOAuth, createAuthorizationUrl } from '@atcute/oauth-browser-client';

import { resolveMiniDoc } from '#/lib/api/slingshot-client';
import { sleep } from '#/lib/utils/sleep';

import { OAUTH_CLIENT_ID, OAUTH_REDIRECT_URI, OAUTH_SCOPE } from '#/env';

export const OAUTH_CALLBACK_PATH = '/oauth/callback';
export const IS_OAUTH_CALLBACK = window.location.pathname === OAUTH_CALLBACK_PATH;

configureOAuth({
	identityResolver: {
		resolve(actor, options) {
			return resolveMiniDoc(actor, options?.signal);
		},
	},
	metadata: {
		client_id: OAUTH_CLIENT_ID,
		redirect_uri: OAUTH_REDIRECT_URI,
	},
});

export async function startOAuthSignIn({ identifier }: { identifier: ActorIdentifier }) {
	const authUrl = await createAuthorizationUrl({
		target: { type: 'account', identifier },
		scope: OAUTH_SCOPE,
	});

	await sleep(200);
	window.location.assign(authUrl);
}
